<!-- Add an empty script block to not get a TS7016 error "Could not find a declaration file for module" in consumers -->
<script lang="ts"></script>

<!-- See app/modules/general/scss/_loader.scss -->
<div class="full-screen-loader"><div></div></div>
